import React, {useState, useEffect, useRef, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context'
import { Link, useHistory } from 'react-router-dom';
// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import { EditorState } from 'draft-js';
// import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
// import draftToHtml from 'draftjs-to-html';
import {  fieldTagOptions,fieldOptions, SMfieldOptions, BMfieldOptions, ITfieldOptions} from '../SignIn/data';
import Modal from '../Ralist/Modal'
import Select from 'react-select';

function Quration() {
  const [quration, setQuration] = useState()
  const [state, actions] = useContext(UserContext);
  
  let user = JSON.parse(String(localStorage.getItem('user')))
  // const header = {Authorization: `JWT ${user.token}`}
  let email = String(localStorage.getItem('email'))
  const history = useHistory()

  const [currentField, setCurrentField] = useState()

  const [currentsingleField, setCurrentsingleField] = useState()

  const [currentJob, setCurrentJob] = useState()

  const [whichfieldOptions, setWhichfieldOptions] = useState()
  const [optionsLen, setOptionsLen] = useState()

  const [transform, setTransform] = useState(0)

  const pagefrom = 0
  const pageto=4

  const [from, setFrom] = useState(pagefrom)
  const [to, setTo] = useState(pageto)

  const [isShowing, setIsShowing] = useState(false)
  


  const ref = useRef();
  const observer = useRef();
  const [page, setPage] = useState(1);
  const [end, setEnd] = useState(false)


  const field = history.location.pathname.split('/')[2]?
  history.location.pathname.split('/')[2].split('&')[0]: null

  const singleField = history.location.pathname.split('/')[2]?
  history.location.pathname.split('/')[2].split('&')[1]: null

  useEffect(()=>{
    
    let fieldparams = []
    
    if(field && !singleField){
      if(field==="반도체"){
        setWhichfieldOptions(SMfieldOptions)
        setOptionsLen(SMfieldOptions.length*162)
        SMfieldOptions.map((item, index)=>{
          fieldparams.push(item.value)
        })
      }
      else if(field==="IT") {
        setWhichfieldOptions(ITfieldOptions)
        setOptionsLen(ITfieldOptions.length*162)
        SMfieldOptions.map((item, index)=>{
          fieldparams.push(item.value)
        })
      }
      else if(field==="바이오"){
        setWhichfieldOptions(BMfieldOptions)
        setOptionsLen(BMfieldOptions.length*162)
        SMfieldOptions.map((item, index)=>{
          fieldparams.push(item.value)
        })
      }
    }
    else if(field && singleField){
      fieldparams.push(singleField)

      if(field==="반도체"){
        setWhichfieldOptions(SMfieldOptions)
        setOptionsLen(SMfieldOptions.length*162)
      }
      else if(field==="IT") {
        setWhichfieldOptions(ITfieldOptions)
        setOptionsLen(ITfieldOptions.length*162)
      }
      else if(field==="바이오"){
        setWhichfieldOptions(BMfieldOptions)
        setOptionsLen(BMfieldOptions.length*162)
      }
    }
    else{
      setWhichfieldOptions(fieldTagOptions)
      setOptionsLen(fieldTagOptions.length*162)
      fieldparams = null
    }


    
    
    // setCurrentField(field)


    const options = {
      // root: document,
      rootMargin: "20px",
      threshold: 1
    };

    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        const newPage = page + 1;
        console.log("fetchagain")
        fetch(state.awslink + "/api/quration/"
          + "?field=" + fieldparams
          + "&from=" + to
          + "&to=" + parseInt(to)*2
          , {
          method: 'GET',
          // headers: header,
          })
        .then(response => response.json())
        .then(json=>{
          console.log(json)
          // setQuration(json)
          if(json.length){
            setFrom(to)
            setTo(parseInt(to)*2)
            if(quration){
              console.log("CONCAT")
              setQuration(quration.concat(json))
              
            }
            else{
              setQuration(json)
            }
          }
          else{
            setEnd(true)
          }
        })
        setPage(newPage);
      }
    };

    observer.current = new IntersectionObserver(callback, options);
    if (ref.current) {
      console.log(ref.current)
      observer.current.observe(ref.current);
    }
    
    


    async function fetchQurationGet(){
      fetch(state.awslink + "/api/quration/"
      + "?field=" + fieldparams
      + "&from=" + from
      + "&to=" + to
      , {
      method: 'GET',
      // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setQuration(json)
        // if(json.length <= to-from){
        //   setEnd(true)
        // }
      }
      )
    }
    
    // if(ralist === null){
    //   console.log('fetch')
    //   if(state.token != undefined)
    if(!quration) fetchQurationGet();

    return () => {
      observer.current.disconnect();
    };

  }, [ref, quration, currentField, history.location.pathname])

  function initData(){
    setQuration(); setFrom(pagefrom); setTo(pageto); setEnd(false);
  }

  

  console.log(whichfieldOptions)
  

  return(
    <>
    <Wrapper>
      <MenuWrapper>
        <div>
          <MenuTitle>
            <li>
              <Link to={'/quration'} onClick={()=>setQuration(null)}>전체</Link>
              
            </li>
            {currentField && <li><Link to={'/quration/'+currentField} onClick={()=>{setQuration(null); setCurrentsingleField()}}>{currentField}</Link></li>}
            {currentsingleField && <li><Link to={'/quration/' + currentField + '&' + currentsingleField} onClick={()=>setQuration(null)}>{currentsingleField}</Link></li>}
          </MenuTitle>
          
          
          <Menu>
            {transform !== 0 && 
            
            <button id={"left"} onClick={()=>{
              if(transform !== 0)setTransform(transform+324)}}>&#60;</button>}
            
            {whichfieldOptions && whichfieldOptions.map((item, index)=>{
              if(whichfieldOptions === fieldTagOptions)
                return(
                  <li style={{transform : `translateX(${transform}px)`, transition: ".5s"}}>
                    <Link to={'/quration/'+ item.value} 
                    onClick={()=>{initData(); setCurrentField(item.value)}}>{item.value}</Link>
                  </li>
                )
              else
                return(
                  <li style={{transform : `translateX(${transform}px)`, transition: ".5s"}}>
                    <Link to={'/quration/'+ currentField + "&" + item.value} 
                    onClick={()=>{initData(); setCurrentField(currentField); setCurrentsingleField(item.value)}}>{item.value}</Link>
                  </li>
                )
            })}
            {optionsLen > state.breakpoint?
            -transform < optionsLen-window.innerWidth*0.9 && 
            <button id={"right"} onClick={()=>{setTransform(transform-324)}}>&#62;</button>
          :null}
          </Menu>
          
          
          
        </div>
      </MenuWrapper>
    {/* <RecCardWrapper >
          {quration ? 
            quration.map((item, index)=>{
              return(
              <li style={raReclist.length < 6 && {float:"left"}}>>
                <div>
                  <Link> 
                    <header style={{backgroundImage: `url("https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/noimage.png")`}}>
                      
                    </header>
                    <div>
                      <div className={"qu-title"} >{item.title}</div>
                    </div>
                  </Link>
                  
                </div>
              </li>)
            })
          :null}
        </RecCardWrapper> */}
      
      
      <QuWrapper>
        <Options>
          {user? 
          <Link to={"/quration/edit/add"}>글쓰기</Link> : 
          <button onClick={()=>actions.setIsShowing(!state.isShowing)}>
            글쓰기          
          </button>
          }
          
        </Options>

        <CardWrapper>
            {quration ? 
              quration.length ?
              quration.map((item, index)=>{
                
                return(
                <Card>
                  <div>
                    <Link to={'/quration/single/'+ item.id }>
                      <div className={"main"}>
                        <img 
                          src = {item.photolink ? item.photolink + "?dummy=123": "dummy"} 
                          onError={(e)=> {
                            e.target.src = state.noimage
                          }}
                        />
                      </div>
                      
                      <div>
                        <div className={"qu-title-quration"}>{item.title}</div>
                      </div>
                    </Link>
                  </div>
                </Card>)
              }):null
            :null}
          
        </CardWrapper>
        {quration && !end ?
          <div ref={ref} style={{ width: "100%", height: "20px" }}>
            Bottom
          </div>
          : null}
      </QuWrapper>
    </Wrapper>   
    {isShowing && 
      <Modal
        isShowing={isShowing}
        hide={()=>setIsShowing(!isShowing)}
        init={()=>{initData(); setIsShowing(!isShowing);}}
        // logout={props.logout}
      />
      }
    </>
  )
}

export default Quration;

const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const QuWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  background-color: whitesmoke;
`

const MenuWrapper = styled.div`
  position: relative;
  height: 140px;
  >div{
    max-width: 1060px;
    width: 90%;
    height: 100%;
    margin: 0 auto;

    
  }
`
const MenuTitle = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  white-space:nowrap;
  >li{
    display: inline-block;
    padding: 5px;
    >a{
      text-decoration: none;
      color: black;
    }
  }
  .ralist-basic-single{
    width: 100px;
  }
`

const Options = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  white-space:nowrap;
  display: flex;
  
  align-items: center;
  >div{
    display: inline-block;
    margin-right: 10px;
    
  }
  .tag-btn{
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background-color: hsl(0, 0%, 100%);
      border-color: hsl(0, 0%, 80%);
      border-radius: 4px;
      border-style: solid;
      border-width: 1px;
      height: 36px;
      width: 100px;

      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      >div{
        cursor: pointer;
        height: 100%;
        display:flex;
        justify-content: center;
        align-items: center;
        :first-child{
          color: hsl(0, 0%, 50%);
          width: 40%;
          border-right: 1px hsl(0, 0%, 80%) solid;
        }
        :last-child{
          width: 60%;
          
        }
      }
    }
  .ralist-basic-single{
    width: 100px;
  }
`
const Menu = styled.ul`
  margin: 0;
  padding: 0;
  height: 52px;
  list-style:none;
  white-space:nowrap;
  overflow: hidden;
  text-align: left;
  position: relative;

  >li{
    
    display: inline-block;
    width: 150px;
    border: .5px solid black;
    height: 50px;
    z-index: 2;
    margin-right: 10px;
    >a{
      background-color: rgba(0,0,0,0.6);
      color: whitesmoke;
      text-decoration: none;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  #left{
    position: absolute;
    height: 52px;
    width: 100px;
    border: none;
    left: 0;
    z-index: 3;
    
    color: rgba(255,255,255,0.8);
    background: linear-gradient(to left, transparent, 60%, black);
    font-size: 2rem;
    text-align: left;
    cursor: pointer;
    opacity: 0.8;
    transition: .2s;
    :hover{
      opacity: 1;
    }
  }
  #right{
    position: absolute;
    height: 52px;
    width: 100px;
    border: none;
    right: 0;
    z-index: 3;
    
    color: rgba(255,255,255,0.8);
    background: linear-gradient(to right, transparent, 60%, black);
    font-size: 2rem;
    text-align: right;
    cursor: pointer;
    opacity: 0.8;
    transition: .2s;
    :hover{
      opacity: 1;
    }
  }
  

`
const RecCardWrapper = styled.ul`
  margin: 0;
  padding: 0;
  /* height: 52px; */
  list-style:none;
  /* white-space:nowrap; */
  /* overflow: auto; */
  /* text-align: left; */
  /* margin: -10px; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 -10px 40px;
  
  @media (max-width: 768px){
      overflow:auto;
      /* width: auto; */
      white-space: nowrap;
    }

  >li{
    display: inline-block;
    vertical-align: top;
    width: calc(20% - 20px);
    
    @media (max-width: 768px){
      width: 35%;
      /* float:none; */
    }

    height: 220px;
    /* padding: 10px; */
    /* border: .5px solid black; */
    z-index: 2;
    box-sizing: border-box;
    margin: 0 10px;

    >div{
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 5px;
      >a{
        display: block;
        
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;

        text-decoration: none;
        >div{
          cursor: pointer;
          color: black;
          padding: 10px;
          
          >div{
            text-align: left;
          }
        }
        
      }
    }

  }

`

const CardWrapper = styled.ul`
  padding: 0;
  content: " ";
  display: table;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  list-style: none;
  list-style-position: outside;
  /* width: 100%; */
  margin: -10px;
  width: calc(100% + 20px);
`

const Card = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * 1.2);
  min-height: 240px;
  max-height: 350px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    >a{
    display: block;
    
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    text-decoration: none;
    >div{
      cursor: pointer;
      color: black;
      padding: 10px;
      box-sizing: border-box;

      
      >div{
        text-align: left;
      }
    }
    .main{
      height: 60%;
      padding: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      border-radius: 5px 5px 0px 0px ;
      >img{
        /* height: 60%; */
        height: 100%;
        background-position-x:50%;
        background-position-y:50%;
        background-size: cover;
        
      }
    }
  }
  }
  
`